module.exports = __webpack_public_path__ + "img/water.e860c84e.png";